import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        { time: 0, name: '91porn', url: 'https://d3fnngjb9o8xlc.cloudfront.net'},
        { time: 0, name: '逼哩逼哩', url: 'https://d1ggzy4ayjqfqg.cloudfront.net'},
        { time: 0, name: '海角乱伦', url: 'https://d1hn3pkhogd1wk.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: '欲漫涩', url: 'https://d2k0j9d4x7wog0.cloudfront.net', webUrl: 'https://d1s8wm47asyysy.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d1ned60becu6s8.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: 'oio禁漫画', url: 'https://d2n72desprztcp.cloudfront.net'},
        { time: 0, name: '萝莉岛', url: 'https://dpm8zwr1hoak6.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d1t86u7h30960d.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },
        
        { time: 0, name: 'Pomhub专业版', url: 'https://d2a3ot8w012093.cloudfront.net' },
        { time: 0, name: '快手视频', url: 'https://dl2tcnch634ob.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d2hvte4l02qd7p.cloudfront.net' },
        { time: 0, name: '妻友', url: 'https://d3eptclsszdagg.cloudfront.net' },
        { time: 0, name: '波多', url: 'https://d2sqb9z7z4a4kh.cloudfront.net/' },
        { time: 0, name: 'Pornhub中文版', url: 'https://d39p7l5r92bkan.cloudfront.net/' },
        { time: 0, name: 'XV暗网', url: 'https://d1pr2q8y4z7h58.cloudfront.net/' },
        { time: 0, name: '稚青社', url: 'https://dpm8zwr1hoak6.cloudfront.net/' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 'lqz01'
        window.open(url + '?dc=' + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
